import React from "react";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import AllBlogs from "../components/Blogs/AllBlogs";
import CommonFooter from "../components/CommonFooter/CommonFooter";

const AllBlogsPage = () => {
  return (
    <div>
      <CommonNavbar hide_btn="d-none" show_btn="d-block" />
      <AllBlogs />
      <CommonFooter />
    </div>
  );
};

export default AllBlogsPage;
